import React, { useEffect } from 'react'
import { useSetRecoilState } from 'recoil'
import { GetRedesSociais, GetTheme, PortalLogout, GetProspectConfigs, UpdatePassword } from '@/domain/usecases'
import { useAuth, useProspectSettings, useThemeClient } from '@/presentation/hooks'
import { InstallationSuggestion, Logout, NavigationDrawer, PhoneModal, SnackBarProvider, UpdatePasswordC, phoneModalNumberState, socialMediaState } from '@/presentation/components'

type RouterProps = {
  getTheme: GetTheme
  getRedesSociais: GetRedesSociais
  getProspectConfigs: GetProspectConfigs
  portalLogout: PortalLogout
  updatePassword: UpdatePassword
}

const Router: React.FC<RouterProps> = ({
  portalLogout,
  getTheme,
  getRedesSociais,
  getProspectConfigs,
  updatePassword
}) => {
  const { isAdmin } = useAuth()
  const { setThemeClient } = useThemeClient()
  const { startConfig } = useProspectSettings()
  const setSocialMedia = useSetRecoilState(socialMediaState)
  const setPhoneModal = useSetRecoilState(phoneModalNumberState)

  useEffect(() => {
    if (!isAdmin()) {
      getTheme
        .get({ codigoUnidade: 0 })
        .then(setThemeClient)
        .catch(console.error)
    }

    getRedesSociais
      .getRedesSociais()
      .then((socialMedias) => {
        setSocialMedia(socialMedias)
        setPhoneModal(socialMedias.phone)
      })
      .catch(console.error)

    getProspectConfigs
      .getAll()
      .then(startConfig)
      .catch(console.error)
  }, [])

  return (
    <>
      <SnackBarProvider />
      <Logout portalLogout={portalLogout} />
      <UpdatePasswordC updatePassword={updatePassword} />
      <InstallationSuggestion />
      <NavigationDrawer />
      <PhoneModal/>
    </>
  )
}

export default Router
